export const GET_EMAIL_SAMPLE = 'GET_EMAIL_SAMPLE';
export const SET_EMAIL_SAMPLE = 'SET_EMAIL_SAMPLE';
export const ERROR_EMAIL_SAMPLE = 'ERROR_EMAIL_SAMPLE';